import script from "./CobrancasEBoletos.vue?vue&type=script&setup=true&lang=js"
export * from "./CobrancasEBoletos.vue?vue&type=script&setup=true&lang=js"

import "./CobrancasEBoletos.vue?vue&type=style&index=0&id=16fafc46&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16fafc46"]])

export default __exports__